import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { resetPassword } from "./AuthService";

export default function ResetPassword(){

  const { token } = useParams();
  const nav = useNavigate();
  const [password,setPassword] = useState("");

  const submit = async (e)=>{
    e.preventDefault();
    await resetPassword(token,password);
    nav("/login");
  };

  return (
    <div style={{
      height:"100vh",
      display:"flex",
      justifyContent:"center",
      alignItems:"center"
    }}>
      <div className="card" style={{ width:"380px" }}>

        <div style={{ textAlign:"center", marginBottom:"15px" }}>
          <h2>Reset Password</h2>
          <p style={{ color:"#6b7280" }}>Create a new secure password</p>
        </div>

        <form onSubmit={submit} className="form-grid" style={{ gridTemplateColumns:"1fr" }}>
          <input
            className="input"
            type="password"
            placeholder="New Password"
            onChange={e=>setPassword(e.target.value)}
            required
          />

          <button className="btn btn-primary" type="submit">
            Reset Password
          </button>
        </form>

      </div>
    </div>
  );
}
